import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 38 38"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.667 28.25H9.75v6.291l7.864-6.291h7.553c1.7 0 3.083-1.383 3.083-3.083V12.833c0-1.7-1.383-3.083-3.083-3.083h-18.5a3.086 3.086 0 0 0-3.083 3.083v12.334c0 1.7 1.382 3.083 3.083 3.083"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M31.333 3.584h-18.5A3.086 3.086 0 0 0 9.75 6.667h18.5c1.7 0 3.083 1.383 3.083 3.084v12.333c1.7 0 3.084-1.383 3.084-3.083V6.667c0-1.7-1.383-3.083-3.084-3.083"
    }, null, -1)
  ]))]))
}
export default { render: render }